module.exports = __webpack_public_path__ + "static/media/bulletin_communal.3dd2ce55.jpeg";